/** @jsx jsx */
import { ButtonComponentProps, ChevronDownIcon } from "@eworkit/iris";
import { AnimatePresence } from "framer-motion";
import React, { ReactElement, ReactNode, useState } from "react";
import { MenuButtonProps } from "reakit/Menu";
import { jsx } from "theme-ui";

import { nestedMenuRevealAnimationStyles, nestedMenuStyles } from "./../config";
import { MenuItem } from "./../Menu";
import { NavButton } from "./../NavItems/NavButton";
import { RevealAnimation } from "./../RevealAnimation";

export interface MobileNestedMenuProps extends ButtonComponentProps, MenuButtonProps {
  buttonContent: ReactNode;
}

type PropsWithMenuChildren<P> = P & { children: ReactElement | ReactElement[] };

export const MobileNestedMenu = React.forwardRef((props: PropsWithMenuChildren<MobileNestedMenuProps>, ref) => {
  const { buttonContent, onClick, children, ...rest } = props;
  const [expanded, setExpanded] = useState<boolean>(false);
  const childrenArray: any[] = React.Children.toArray(props.children);
  return (
    <React.Fragment>
      <MenuItem
        sx={nestedMenuStyles}
        as={NavButton}
        ref={ref}
        {...rest}
        iconRight={<ChevronDownIcon />}
        aria-expanded={expanded}
        onClick={(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
          setExpanded(v => !v);
          if (typeof onClick === "function") {
            onClick(e);
          }
        }}>
        {buttonContent}
      </MenuItem>
      <AnimatePresence>
        {expanded && (
          <RevealAnimation sx={nestedMenuRevealAnimationStyles}>
            {childrenArray.map(child => React.cloneElement(child))}
          </RevealAnimation>
        )}
      </AnimatePresence>
    </React.Fragment>
  );
});
